import axios from "axios";

export const getSettings = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Settings/settings`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
